import React from "react";
import { useMode } from "../../context/useMode";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ensureUser } from "../../utils/userUtils";
import { useLocale } from "../../context/useLocale";

interface ModeChoiceProps {
  isSelected: boolean;
  mode: "light" | "dark";
  classNames: {
    container: string;
    title: string;
    description: string;
  };
  translationPrefix: string;
  showDarkWarning?: boolean;
}

const ModeChoice: React.FC<ModeChoiceProps> = ({
  isSelected,
  mode,
  classNames,
  translationPrefix,
  showDarkWarning = false,
}) => {
  const { setMode } = useMode();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { selectedLocale } = useLocale();
  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;

  const handleClick = async () => {
    await ensureUser(mode, selectedLocale.value);
    setMode(mode);
    if (showDarkWarning && !handle?.user?.dark_mode_warning_shown) {
      navigate("/dark-warning");
    } else {
      navigate("/questionnaire");
    }
  };

  return (
    <div className={classNames.container}>
      <h3 className={classNames.title}>{t(`${translationPrefix}Title`)}</h3>
      {/* SOUL textbox */}
      <div 
        className={`inline-block py-1 rounded text-white font-bold text-25 uppercase mt-2 ${
          mode === "light" ? "bg-light-soul" : "bg-dark-soul"
        }`}
        style={{ alignSelf: mode === "light" ? "flex-end" : "flex-start" }}
      >
        SOUL
      </div>
      <div className={classNames.description}>
        <div className="flex-1 overflow-y-auto min-h-0 max-h-[48vh] hide-scrollbar">
          <p
            dangerouslySetInnerHTML={{
              __html: t(`${translationPrefix}Description`),
            }}
          />
          <p className="mt-2">{t(`${translationPrefix}Disclaimer`)}</p>
        </div>
      </div>
      <div
        className={
          mode === "light" ? "flex items-end pt-5" : "flex-1 flex items-end"
        }
      >
        <button
          onClick={handleClick}
          className={`btn-green btn-begin mx-auto uppercase ${isSelected && "pulse-audio"}`}
        >
          {t(`beginWith${mode.charAt(0).toUpperCase() + mode.slice(1)}`)}
        </button>
      </div>
    </div>
  );
};

export default ModeChoice;
